module.exports = __webpack_public_path__ + "static/media/allergen_treenut.8fb7ba75.8fb7ba75.png";